<section class="pt-16 pb-8 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Definizioni', route: '/backoffice/abbecedario/' }, { label: 'Aggiungi Definizione', route: '/backoffice/abbecedario/add' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">AGGIUNGI DEFINIZIONE</h1>
</section>


<section class="pb-16 mb-8 px-container">

    <form [formGroup]="formDefinizione" (ngSubmit)="onSubmit()">
        <div class="flex flex-col gap-8">                                                                
            <div class="w-full">
                <label>* Alfabeto</label>
                <p-dropdown [options]="alfabeto" optionLabel="lettera" placeholder="Seleziona una lettera dell'alfabeto" formControlName="alfabeto"></p-dropdown>
                <small class="text-red-600 block mt-4 font-medium" *ngIf="formDefinizione.get('alfabeto')?.hasError('required') && (formDefinizione.get('alfabeto')?.dirty || formDefinizione.get('alfabeto')?.touched)">La lettera dell'alfabeto è obbligatoria!.</small>
            </div>
            <div class="w-full">
                <label>* Titolo</label>
                <input type="text" pInputText placeholder="Titolo" formControlName="titolo" name="titolo" id="titolo" required />
                <small class="text-red-600 block mt-4 font-medium" *ngIf="formDefinizione.get('titolo')?.hasError('required') && (formDefinizione.get('titolo')?.dirty || formDefinizione.get('titolo')?.touched)">Il titolo è obbligatorio!.</small>
            </div>                                                                     
            <div class="w-full">
                <label>* Definizione</label>
                <p-editor [style]="{ height: '150px' }" formControlName="definizione" (ngModelChange)="onDefinizione($event)" />
                <small class="text-red-600 block mt-4 font-medium" *ngIf="formDefinizione.get('definizione')?.hasError('required') && (formDefinizione.get('definizione')?.dirty || formDefinizione.get('definizione')?.touched)">La descrizione è obbligatorio!.</small>
            </div>                
            <button class="btn-outln-backoffice p-3 w-full font-medium" type="submit" [disabled]="!formDefinizione.valid">Aggiungi</button>
        </div>
    </form>

</section>